import React ,{useRef}from "react";
import AxiosInstance from "../AxiosInstance";
import { Button } from "react-bootstrap";
import { Download } from "react-bootstrap-icons";
import ToastNotification from "../ToastNotification";

const DownloadProfileButton = ({ userId, userName }) => {
  const toastRef = useRef(null);
  const handleDownload = async () => {
    try {
      const response = await AxiosInstance.get(`/common/download-profile/${userId}`, {
        responseType: "blob", // Important to handle file downloads
      });

      // Create a blob URL and trigger the download
      const blob = new Blob([response.data]);
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${userName}_profile.jpg`; // File name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      toastRef.current?.showToast("Error downloading profile picture:", "danger");
    }
  };

  return (
    <div>
      <Button className="btn btn-outline-secondary mt-3"style={{ color: "white" }} onClick={handleDownload}>
      <Download />
    </Button>
    <ToastNotification ref={toastRef} />
    </div>
    
  );
};

export default DownloadProfileButton;
